export default __webpack_public_path__ + "static/media/sunrise.e387d2ce.svg";